import { useI18n } from "../../utils/translate/i18n/useI18n";
import type { TestParameters } from "../../type/result";
import { AGE_CATEGORY_OPTIONS, GENDER_OPTIONS, HEADPHONE_CONNECTION_OPTIONS, HEADPHONE_TYPE_OPTIONS } from "../../type/demographics";
import "./tonalParamsBadges.scss";

type Props = {
  params: Partial<TestParameters>;
};

export default function TonalParamsBadges({ params }: Props) {
  const { t } = useI18n();

  const items: { key: keyof TestParameters; label: string }[] = [
    { key: "adaptTest", label: t("Test adaptacyjny") },
    { key: "randomTest", label: t("Losowy test") },
    { key: "continuous", label: t("Dźwięk ciągły") },
    { key: "addNoise", label: t("Dodaj szum") },
  ];

  const active = items.filter(item => params[item.key]);

  const demographics: { key: string; label: string }[] = [];
  if (params.gender && params.gender !== "unspecified") {
    const option = GENDER_OPTIONS.find(o => o.value === params.gender);
    if (option) demographics.push({ key: "gender", label: t(option.label) });
  }
  if (params.ageCategory && params.ageCategory !== "unspecified") {
    const option = AGE_CATEGORY_OPTIONS.find(o => o.value === params.ageCategory);
    if (option) demographics.push({ key: "ageCategory", label: t(option.label) });
  }
  if (params.headphoneType && params.headphoneType !== "unspecified") {
    const option = HEADPHONE_TYPE_OPTIONS.find(o => o.value === params.headphoneType);
    if (option) demographics.push({ key: "headphoneType", label: t(option.label) });
  }
  if (params.headphoneConnection && params.headphoneConnection !== "unspecified") {
    const option = HEADPHONE_CONNECTION_OPTIONS.find(o => o.value === params.headphoneConnection);
    if (option) demographics.push({ key: "headphoneConnection", label: t(option.label) });
  }

  const allItems = [...active, ...demographics];

  if (allItems.length === 0) return null;

  return (
    <p className="mb-0 mt-1 test-params-badges">
      <i className="bi bi-sliders me-1" />
      {allItems.map((item, index) => (
        <span key={item.key} className="test-params-badges__badge">
          {item.label}{index < allItems.length - 1 ? "," : ""}
        </span>
      ))}
    </p>
  );
}
